/* ==========================================================================
   MaxGlows — keep the retired white-teeth guide out of the cart   2026-09-05

   "המדריך לשיניים לבנות תוך 7 ימים" was retired on 3.9, but it still lands in
   the cart as a ₪0 line on nearly every order.

   WHERE IT COMES FROM  (measured on the live store, 3.9, with ?mgdebug=1)

     The browser only ever sends two add requests: the spray, and the theme's
     own gift "סודות המשיכה". Neither carries the guide - both were inspected
     and left untouched - and the cart still comes back holding it:

        2040ms  fetch ADD   id=<spray>            -> left untouched
        3111ms  fetch ADD   id=<gift>             -> left untouched
        3512ms  cart.js     items=3  guideInCart=true

     So the guide is added server-side, outside this page. Nothing done to an
     outgoing request can prevent it, which is why the earlier versions that
     edited the add payload never worked. It has to be removed after the fact.

   HOW IT IS REMOVED WITHOUT A REDRAW

     The bin sends the line number the drawer was drawn with, so deleting a
     line server-side and leaving the DOM alone breaks it - that was v4/v5
     ("הפרמטר line אינו חוקי"). Redrawing the whole drawer fixes the numbers
     but costs a visible refresh - that was v6.

     Neither is necessary. The stray line is dropped from the DOM and the
     remaining rows are renumbered exactly the way the Liquid numbers them
     (CartDrawer-Item-N / CartDrawer-Remove-N / Drawer-quantity-N and their
     data-index). The cart and the page agree, the bin works, and nothing is
     redrawn.

   NOT OURS: the two redraws after adding to cart are the theme's own gift
   blocks - the second add above asks the server for fresh sections, which is
   a redraw by definition. Confirmed by running the store with this file
   removed. Nothing here touches that.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__mgNoStrayGift) return;
  window.__mgNoStrayGift = true;

  var STRAY_PRODUCT_IDS = [8403831881816];

  /* Escaped, not literal: the selector must survive even if this file is ever
     served with the wrong charset. ("המדריך-לשיניים-לבנות-תוך-7-ימים") */
  var STRAY_HANDLE = '\u05d4\u05de\u05d3\u05e8\u05d9\u05da-\u05dc\u05e9\u05d9\u05e0\u05d9\u05d9\u05dd-\u05dc\u05d1\u05e0\u05d5\u05ea-\u05ea\u05d5\u05da-7-\u05d9\u05de\u05d9\u05dd';
  var STRAY_CLASS = 'cart-item--product-' + STRAY_HANDLE;

  var CART_WRITE = /\/cart\/(add|change|update)/;

  /* ---------- 1. never let it be seen --------------------------------- */

  (function hideRule() {
    try {
      /* The handle is Hebrew and a bare class selector built from it does not
         survive the CSS parser - matched as an attribute substring instead,
         which takes a quoted string and needs no escaping. */
      var style = document.createElement('style');
      style.textContent = '[class*="' + STRAY_CLASS + '"]{display:none !important;}';
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}
  })();

  /* ---------- 2. keep the page and the cart telling the same story ----- */

  /* Mirrors blocks/cart-drawer_items.liquid, which numbers every row with
     item.index + 1 in four places. Drop the stray row, renumber the rest. */
  function dropStrayRowsAndRenumber() {
    var rows = document.querySelectorAll('li.cart-item');
    if (!rows.length) return 0;

    var removed = 0;
    var n = 0;
    Array.prototype.forEach.call(rows, function (li) {
      if (li.className.indexOf(STRAY_CLASS) !== -1) {
        if (li.parentNode) li.parentNode.removeChild(li);
        removed++;
        return;
      }
      n++;
      li.setAttribute('data-index', n);
      li.id = 'CartDrawer-Item-' + n;

      var remove = li.querySelector('cart-remove-button');
      if (remove) {
        remove.setAttribute('data-index', n);
        remove.id = 'CartDrawer-Remove-' + n;
      }
      var qty = li.querySelector('.quantity__input');
      if (qty) {
        qty.setAttribute('data-index', n);
        qty.id = 'Drawer-quantity-' + n;
      }
      var err = li.querySelector('.cart-item__error');
      if (err) err.id = 'CartDrawer-LineItemError-' + n;
    });
    return removed;
  }


  /* ==================================================================
     THE VIP ADD-ON

     The card is the theme's own upsell block; everything below is
     presentation plus one click forwarder. No markup is rewritten and no
     setting is changed, so adding and removing the product still runs
     entirely through the theme.

     What it fixes, and why each one matters for how many people take it:
       - the title already names the three benefits, so nothing repeats them
       - only the 40px switch was tappable; the whole card is now the target
       - "on" was easy to miss; the card now lights up
       - the proof line sat outside the card; it moves inside, next to the
         decision
     ================================================================== */
  var VIP_HANDLE = '\u05d1\u05d9\u05d8\u05d5\u05d7-\u05de\u05e9\u05dc\u05d5\u05d7-\u05e2\u05d3\u05d9\u05e4\u05d5\u05ea-\u05d0\u05e8\u05d9\u05d6\u05d4';   /* the VIP add-on product */
  var VIP_SEL = 'cart-drawer-upsell[data-handle="' + VIP_HANDLE + '"]';

  (function vipStyle() {
    try {
      var css = [
        /* the card */
        VIP_SEL + '{display:block;direction:rtl;position:relative;overflow:hidden;',
        'border-radius:1.4rem;border:1.5px solid #e3d7ff;',
        'background:linear-gradient(180deg,#faf7ff 0%,#f4ecff 100%);',
        'transition:border-color .18s ease,background .18s ease,box-shadow .18s ease;}',

        /* on - unmistakable without shouting */
        VIP_SEL + '[data-selected="true"]{border-color:#a473df;',
        'background:linear-gradient(180deg,#f5edff 0%,#ece0ff 100%);',
        'box-shadow:0 0 0 3px rgba(164,115,223,.16);}',

        /* the recommendation flag, in the corner the eye reaches first in Hebrew */
        VIP_SEL + '::before{content:"\u05de\u05d5\u05de\u05dc\u05e5";position:absolute;top:0;right:0;z-index:1;',
        'background:#a473df;color:#fff;font-size:.95rem;font-weight:700;line-height:1;',
        'padding:.4rem .8rem;border-radius:0 1.4rem 0 1rem;letter-spacing:.02em;}',

        /* the proof, inside the card where the decision is made */
        VIP_SEL + '::after{content:"\ud83d\udd25 84% \u05de\u05d4\u05e8\u05d5\u05db\u05e9\u05d9\u05dd \u05de\u05d5\u05e1\u05d9\u05e4\u05d9\u05dd \u05d0\u05ea \u05d6\u05d4";display:block;',
        'border-top:1px solid #e8dcff;background:rgba(255,255,255,.45);',
        'padding:.55rem 1.2rem;font-size:1.1rem;line-height:1.4;color:#6b5a86;',
        'text-align:right;}',

        /* the row. The top padding clears the corner flag so the flag never
           sits on top of the image or the title. */
        VIP_SEL + ' .upsell__container{display:flex;align-items:center;gap:.9rem;',
        'padding:1.9rem 1.2rem 1.1rem;cursor:pointer;}',

        VIP_SEL + ' .upsell__image{width:4rem;min-width:4rem;height:4rem;border-radius:.9rem;',
        'overflow:hidden;background:#fff;border:1px solid #e8dcff;}',
        VIP_SEL + ' .upsell__image__img{width:100%;height:100%;object-fit:contain;}',

        /* the title now carries the whole offer on its own, so it gets the
           room the three benefit lines used to take */
        VIP_SEL + ' .upsell__content{flex:1 1 auto;min-width:0;}',
        VIP_SEL + ' .upsell__title{display:flex;align-items:center;column-gap:.7rem;',
        'row-gap:.6rem;flex-wrap:wrap;}',
        VIP_SEL + ' .upsell__title h3{margin:0;font-size:1.3rem;font-weight:700;',
        'line-height:1.4;color:#1f1533;}',

        /* the price reads as an addition, not as a second product */
        VIP_SEL + ' .upsell__price{margin:0;}',
        VIP_SEL + ' .upsell__price .regular-price{display:inline-block;background:#fff;',
        'border:1px solid #d9c6f5;color:#6d3fa8;font-size:1.15rem;font-weight:700;',
        'padding:.25rem .7rem;border-radius:999px;white-space:nowrap;line-height:1.25;}',
        /* a compare-at price, if one is ever set, reads as the saving - it is
           not hidden, only kept quiet next to the pill */
        VIP_SEL + ' .upsell__price .compare-price{font-size:1.15rem;color:#8b7aa6;',
        'text-decoration:line-through;margin-inline-start:.4rem;}',
        VIP_SEL + ' .upsell__price .compare-price.hidden{display:none;}',

        VIP_SEL + ' .toggle-switch{flex:0 0 auto;}',

        /* the old proof line and its arrow, now that both live in the card */
        '#CartDrawer .cart-drawer-text-with-icon:has(em){display:none;}',

        '@media screen and (max-width:480px){',
        VIP_SEL + ' .upsell__container{padding:1.8rem 1rem 1rem;gap:.8rem;}',
        VIP_SEL + ' .upsell__image{width:3.6rem;min-width:3.6rem;height:3.6rem;}',
        VIP_SEL + ' .upsell__title h3{font-size:1.25rem;line-height:1.4;}',
        VIP_SEL + ' .upsell__price .regular-price{font-size:1.1rem;}',
        VIP_SEL + '::after{padding:.5rem 1rem;font-size:1.05rem;}}'
      ].join('');

      var style = document.createElement('style');
      style.setAttribute('data-mg', 'vip');
      style.textContent = css;
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}
  })();

  /* The whole card takes the tap, not just the switch. Delegated, so it keeps
     working through every redraw of the drawer, and it forwards the click
     rather than touching the cart itself - the theme still owns that. */
  document.addEventListener('click', function (e) {
    var card = e.target && e.target.closest && e.target.closest(VIP_SEL);
    if (!card) return;
    var toggle = card.querySelector('.upsell__toggle-switch');
    if (!toggle || toggle === e.target || toggle.contains(e.target)) return;
    e.preventDefault();
    toggle.click();
  }, false);


  /* ==================================================================
     THE DRAWER MUST REACH THE BOTTOM OF THE SCREEN

     Measured on the live store (3.9): the drawer element itself is already
     full height - top 0, bottom 656 on a 656px viewport - but its inner
     panel is only as tall as its content and carries no background of its
     own. With a subscription in the cart there is an extra line and the
     content happens to fill the screen; with a one-time purchase it is
     shorter, ends just under the checkout button, and the product page
     shows through underneath.

     min-height rather than height, so a long cart still scrolls normally.
     ================================================================== */
  (function fillDrawer() {
    try {
      var style = document.createElement('style');
      style.setAttribute('data-mg', 'drawer-fill');
      /* Two floors, because one of them moves: 100% leans on the parent's
         height, which iOS recalculates while Safari's address bar slides in
         and out - that is the "sometimes" in the panel sometimes ending short
         with the page showing through. 100dvh is the full dynamic viewport
         and does not flinch when the bar moves; older browsers that don't
         know it keep the 100% line. */
      /* the full-width mobile drawer covers the screen anyway, so the whole
         fixed container gets the background too - whatever the inner panel
         measures on any given open, the page behind cannot peek through */
      style.textContent =
        '#CartDrawer .drawer__inner{min-height:100%;background:#fff;}' +
        '@supports (min-height:100dvh){#CartDrawer .drawer__inner{min-height:100dvh;}}' +
        '@media screen and (max-width:749px){' +
        'cart-drawer.cart-drawer--mobile-width-full #CartDrawer{background:#fff;}}';
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}
  })();

  /* ==================================================================
     THE GIFTS BOX APPEARS ONCE, COMPLETE

     Adding the spray sets off a chain the page cannot shorten: the theme's
     gift blocks each add their own gift with a fresh drawer render between
     them, and the retired guide arrives server-side in the middle and is
     removed again. Seen live (3.9), the gifts panel counted 2 - 4 - 3 while
     that chain ran.

     The chain itself belongs to the theme and keeps running untouched. What
     changes is only what the customer sees: from the moment an add-to-cart
     leaves a closed drawer until the cart has been quiet for a beat, the
     gifts panel stays hidden, then fades in once - complete, in order.

     A closed drawer is the tell for "this is the opening chain". Later
     writes with the drawer already open (the VIP switch, an upsell toggle)
     never hide the panel.
     ================================================================== */
  var settle = (function () {
    var QUIET_MS = 900;   /* the chain is done when the cart stays quiet this long */
    var CAP_MS = 7000;    /* and never hide the panel longer than this */
    var quiet = null;
    var cap = null;
    var on = false;

    try {
      var style = document.createElement('style');
      style.setAttribute('data-mg', 'settle');
      style.textContent =
        'cart-drawer.mg-settling .mg-gifts{display:none !important;}' +
        'cart-drawer .mg-gifts{animation:mgGiftsIn .35s ease both;}' +
        'cart-drawer.mg-settling .mg-payeo-line{visibility:hidden !important;}' +
        'cart-drawer .mg-payeo-line{animation:mgGiftsIn .35s ease both;}' +
        'cart-drawer.mg-settling .drawer__inner,cart-drawer.mg-settling #CartDrawer{position:relative;}' +
        '.mg-veil{position:absolute;inset:0;z-index:20;background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:1.2rem;direction:rtl;text-align:center;color:#5a3e9a;font-size:1.5rem;font-weight:600;opacity:1;transition:opacity .25s ease;pointer-events:none;}' +
        '.mg-veil.mg-veil--out{opacity:0;}' +
        '.mg-veil__spin{width:2.8rem;height:2.8rem;border-radius:50%;border:.3rem solid #e9defc;border-top-color:#a473df;animation:mgSpin .8s linear infinite;}' +
        '@keyframes mgSpin{to{transform:rotate(360deg);}}' +
        '@media (prefers-reduced-motion: reduce){.mg-veil__spin{animation:none;}}' +
        '@keyframes mgGiftsIn{from{opacity:0;transform:translateY(4px);}to{opacity:1;transform:none;}}' +
        '@media (prefers-reduced-motion: reduce){cart-drawer .mg-gifts{animation:none;}}';
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}

    function drawer() { return document.querySelector('cart-drawer'); }

    /* ---- the veil ------------------------------------------------------
       Shrine redraws the whole drawer after every add in the opening chain
       (spray, each gift, the VIP): the product row and the VIP card are
       replaced and re-animated four or five times in about a second, and
       one of those redraws is a half-styled frame of the cart page (seen
       on the 5.9 recording). Rather than fight each redraw, the panel is
       covered with a plain white veil and a small spinner from the moment
       it opens until the cart is quiet; then the veil fades and the
       finished cart is shown once. The veil lives INSIDE the panel (so it
       follows its geometry) and is put back after every redraw, since
       redraws replace the panel's children. */
    var VEIL_TEXT = 'מוסיפים את המתנות שלך… 🎁';
    var veilOn = false;
    var veilMo = null;

    function panel() {
      var d = drawer();
      return d && (d.querySelector('.drawer__inner') || d.querySelector('#CartDrawer'));
    }
    function ensureVeil() {
      if (!veilOn) return;
      var p = panel();
      if (!p) return;
      if (p.querySelector(':scope > .mg-veil')) return;
      var v = document.createElement('div');
      v.className = 'mg-veil';
      v.setAttribute('aria-hidden', 'true');
      v.innerHTML = '<div class="mg-veil__spin"></div><div>' + VEIL_TEXT + '</div>';
      p.appendChild(v);
    }
    function veil(show) {
      veilOn = !!show;
      var d = drawer();
      if (show) {
        ensureVeil();
        if (!veilMo && d) {
          veilMo = new MutationObserver(function () { ensureVeil(); });
          veilMo.observe(d, { childList: true, subtree: true });
        }
      } else {
        if (veilMo) { veilMo.disconnect(); veilMo = null; }
        Array.prototype.forEach.call(document.querySelectorAll('.mg-veil'), function (v) {
          v.classList.add('mg-veil--out');
          setTimeout(function () { if (v.parentNode) v.parentNode.removeChild(v); }, 300);
        });
      }
    }

    function end() {
      if (quiet) { clearTimeout(quiet); quiet = null; }
      if (cap) { clearTimeout(cap); cap = null; }
      on = false;
      var d = drawer();
      if (d) d.classList.remove('mg-settling');
      veil(false);
    }

    function touch() {
      if (!on) return;
      if (quiet) clearTimeout(quiet);
      quiet = setTimeout(end, QUIET_MS);
    }

    function begin() {
      if (!on) {
        var d = drawer();
        if (!d) return;
        on = true;
        d.classList.add('mg-settling');
        veil(true);
        cap = setTimeout(end, CAP_MS);
      }
      touch();
    }

    /* an add that leaves a CLOSED drawer starts the chain; anything else
       only keeps an already-running window open */
    function onCartWrite(url) {
      var d = drawer();
      if (/\/cart\/add/.test(url) && d && !d.classList.contains('active')) begin();
      else touch();
    }

    /* Payeo writes a "תדירות מנוי: ..." line under the subscription item
       after every redraw of the drawer. Three redraws in the opening chain
       = the line popping in three times. It is tagged the moment it is
       inserted (a MutationObserver runs before paint) and the CSS above
       keeps it invisible - layout intact, so nothing jumps - until the
       chain is over, when it fades in once with the gifts. */
    var PAYEO_LINE = /^\s*תדירות מנוי/;
    function tagPayeoLine(root) {
      if (!root || root.nodeType !== 1) return;
      var nodes = [root].concat(Array.prototype.slice.call(root.querySelectorAll('*')));
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.classList.contains('mg-payeo-line')) continue;
        if (!PAYEO_LINE.test(el.textContent || '')) continue;
        var leaf = true;
        for (var c = 0; c < el.children.length; c++) {
          if (PAYEO_LINE.test(el.children[c].textContent || '')) { leaf = false; break; }
        }
        if (leaf) el.classList.add('mg-payeo-line');
      }
    }
    try {
      new MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var m = list[i];
          if (m.type === 'characterData') { tagPayeoLine(m.target.parentNode); continue; }
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            tagPayeoLine(n.nodeType === 3 ? n.parentNode : n);
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
      tagPayeoLine(drawer());
    } catch (e) {}

    return { onCartWrite: onCartWrite, touch: touch };
  })();

  /* ==================================================================
     THE CHECKOUT BUTTON SPEAKS HEBREW

     With a subscription in the cart, Payeo's own script intercepts the
     checkout click and rewrites the button label to "Processing..." - an
     English word on an all-Hebrew store, at the most sensitive moment of
     the purchase. The script is external and cannot be edited, so the swap
     is caught here the instant it happens and replaced with Hebrew.

     Only ever rewrites a label that says "Processing" - one write, after
     which the text no longer matches, so the observer cannot loop.
     ================================================================== */
  (function hebrewCheckout() {
    /* "\u05e2\u05d5\u05d1\u05e8\u05d9\u05dd \u05dc\u05ea\u05e9\u05dc\u05d5\u05dd \u05de\u05d0\u05d5\u05d1\u05d8\u05d7..." */
    var HEB = '\u05e2\u05d5\u05d1\u05e8\u05d9\u05dd \u05dc\u05ea\u05e9\u05dc\u05d5\u05dd \u05de\u05d0\u05d5\u05d1\u05d8\u05d7\u2026';
    var RX = /\.*\s*processing\s*\.*/i;

    function fix() {
      var btns = document.querySelectorAll(
        'button[name="checkout"], .cart__checkout-button, #CartDrawer-Checkout'
      );
      Array.prototype.forEach.call(btns, function (b) {
        if (!RX.test(b.textContent || '')) return;
        var walker = document.createTreeWalker(b, NodeFilter.SHOW_TEXT, null);
        var n;
        while ((n = walker.nextNode())) {
          if (RX.test(n.nodeValue || '')) n.nodeValue = n.nodeValue.replace(RX, HEB);
        }
      });
    }

    try {
      new MutationObserver(fix).observe(document.documentElement, {
        childList: true, subtree: true, characterData: true
      });
    } catch (e) {}
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fix);
    } else {
      fix();
    }
  })();

  /* ==================================================================
     THE VIP RENEWS WITH THE SUBSCRIPTION

     What was learned from order #19472 (4.9, 22:21 - the first order after
     the previous version went live): Payeo does not use Shopify selling
     plans at checkout at all. The spray line has sellingPlan = null; the
     subscription lives entirely in line-item PROPERTIES that Payeo's widget
     writes when the item is added:

        _Subscription_Plan_ID             2100265048
        חבילה                             <plan name>       (the one visible line)
        _Subscription_Plan_Name           <plan name>
        _Subscription_Price_Per_Delivery  238.40
        _Subscription_Compare_At_Price    298.00
        _Subscription_Discount_Type       percentage
        _Subscription_Discount_Value      20
        _Subscription_Currency            ₪

     and Payeo builds the renewal from those. The earlier approach - adding
     selling_plan to the VIP add - therefore could never reach the renewal,
     and could only have upset a checkout whose gateway does not take
     Shopify subscriptions.

     Now: the VIP is given the same properties, ON THE SPRAY'S OWN PLAN -
     same plan id, same plan name - so Payeo sees one subscription with two
     lines, not two subscriptions. Its price per delivery is its own (19.90,
     no discount); Payeo keeps that per line, which is why the property
     exists per line at all. Done whenever - and only when - a subscription
     spray line is in the cart. Done on the cart itself, after
     the fact, so it does not matter how the VIP got there (the default-on
     card, the switch, a re-add). If the customer later drops the
     subscription, the VIP's plan is taken off again. A one-time cart never
     gets touched.
     ================================================================== */
  (function vipRenews() {

    var VIP_VARIANT = 44129537523800;
    /* The VIP rides on whatever plan the spray line carries (copied from it
       at the time). Payeo's separate "VIP" plan (162) is deliberately NOT
       used - a second plan id would make a second subscription.

       Price: the VIP must renew at its full price (19.90), never at the
       plan's 20% off. Payeo reads the discount from the line's own
       _Subscription_Discount_Value (proved at checkout: copying the plan's
       20 onto the VIP line produced a -3.98 discount on it), so the VIP
       line says 0 and 19.90 both as price-per-delivery and compare-at. */
    var PLAN_KEY = '_Subscription_Plan_ID';
    var VIP_LABEL = 'חודשי מתחדש';           /* the visible line under the VIP at checkout */
    var VIP_PLAN_ID = '2216493144';           /* Payeo plan 162, group "VIP": every 4 weeks, 0% */
    var MG_MARK = '_mg_vip_plan';               /* so our own write is recognisable */

    var busy = false;
    var fixes = 0;
    var MAX_FIXES = 40;                          /* per page - a loop guard only; a customer toggling the
                                                    subscription on and off costs one fix each way */

    function money2(cents) { return (cents / 100).toFixed(2); }

    function isSubLine(it) {
      var p = (it && it.properties) || {};
      return !!p[PLAN_KEY] && String(it.variant_id) !== String(VIP_VARIANT);
    }

    function planProps(vip, subLine) {
      var sp = (subLine && subLine.properties) || {};
      var props = {};
      var cents = vip.original_price || vip.price;                 /* 1990 */
      /* Seen at checkout on 5.9, twice: with the VIP on the spray's plan
         Payeo's checkout discount took 20% off it (-3.98) - whether the
         line said 20 or 0. So the discount comes from the PLAN in Payeo,
         and the VIP has to sit on its own 0% plan to stay at full price. */
      props[PLAN_KEY] = VIP_PLAN_ID;
      props['חבילה'] = VIP_LABEL;                 /* what the customer sees under the VIP at checkout */
      props['_Subscription_Plan_Name'] = VIP_LABEL;
      props['_Subscription_Price_Per_Delivery'] = money2(cents);
      props['_Subscription_Compare_At_Price'] = money2(cents);
      props['_Subscription_Discount_Type'] = 'percentage';
      props['_Subscription_Discount_Value'] = '0';
      props['_Subscription_Currency'] = sp['_Subscription_Currency'] || '₪';
      props[MG_MARK] = '1';
      return props;
    }

    function post(url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json(); });
    }

    function reconcile() {
      if (busy || fixes >= MAX_FIXES) return;
      busy = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var items = (cart && cart.items) || [];
          var vip = null, sub = null;
          items.forEach(function (it) {
            if (String(it.variant_id) === String(VIP_VARIANT)) vip = it;
            else if (isSubLine(it)) sub = sub || it;
          });
          if (!vip) return null;
          var vp = vip.properties || {};
          var vipHasPlan = !!vp[PLAN_KEY];
          var vipOnOwnPlan = vipHasPlan && String(vp[PLAN_KEY]) === VIP_PLAN_ID && vp['_Subscription_Discount_Value'] === '0';

          if (sub && (!vipHasPlan || (!vipOnOwnPlan && vp[MG_MARK]))) {
            /* subscription in the cart, VIP still one-off -> put it on the plan */
            fixes++;
            return post('/cart/change.js', { id: vip.key, quantity: vip.quantity, properties: planProps(vip, sub) })
              .then(function () { announce('vip-plan-on'); });
          }
          if (!sub && vipHasPlan && (vip.properties || {})[MG_MARK]) {
            /* subscription gone, VIP still carries the plan we put on -> take it off:
               a line's properties cannot be cleared in place, so it is re-added plain */
            fixes++;
            return post('/cart/change.js', { id: vip.key, quantity: 0 })
              .then(function () { return post('/cart/add.js', { items: [{ id: VIP_VARIANT, quantity: vip.quantity }] }); })
              .then(function () { announce('vip-plan-off'); });
          }
          return null;
        })
        .catch(function () {})
        .then(function () { busy = false; });
    }

    function announce(what) {
      try { document.dispatchEvent(new CustomEvent('mg:vip-plan', { detail: what })); } catch (e) {}
      /* the drawer does not need redrawing - the VIP line is hidden in it -
         but Payeo's own widget listens for cart changes, so let it know */
      try { document.dispatchEvent(new CustomEvent('mg:cart-written')); } catch (e) {}
    }

    var timer = null;
    function soon() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () { timer = null; reconcile(); }, 350);
    }

    /* every cart write (adds, Payeo's own property updates, quantity changes)
       is followed by a look at the cart. The 350ms coalesces the opening
       chain into one look at the end. */
    document.addEventListener('mg:cart-written', soon);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon);
    else soon();
  })();

  /* ---------- 3. and take it out of the cart itself -------------------- */

  var MAX_SWEEPS = 4;
  var sweeps = 0;
  var busy = false;

  function sweep() {
    if (busy || sweeps >= MAX_SWEEPS) return;
    busy = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = {};
        var found = false;
        ((cart && cart.items) || []).forEach(function (it) {
          if (STRAY_PRODUCT_IDS.indexOf(it.product_id) !== -1) {
            updates[it.variant_id] = 0;
            found = true;
          }
        });
        if (!found) return;

        sweeps++;
        /* No `sections`: asking for them is what makes the server hand back a
           drawer to redraw, and the numbering is corrected here instead. */
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
          .then(function () { dropStrayRowsAndRenumber(); })
          .catch(function () {});
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  var queued = false;
  function queue(delay) {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; sweep(); }, delay || 200);
  }

  /* ---------- wiring --------------------------------------------------- */

  /* The drawer is re-rendered by the theme on every cart change, which brings
     the stray row back into the DOM with fresh numbering. Each render is
     followed up: the row goes, the numbers close the gap. */
  /* Matched as an attribute substring, never as a class selector: the handle
     is Hebrew, and building a class selector out of it is what silently broke
     an earlier version's CSS. */
  var STRAY_SELECTOR = 'li.cart-item[class*="' + STRAY_CLASS + '"]';

  new MutationObserver(function () {
    if (document.querySelector(STRAY_SELECTOR)) dropStrayRowsAndRenumber();
  }).observe(document.documentElement, { childList: true, subtree: true });

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      /* bound to window, never to the caller: native fetch refuses any other
         receiver, and a strict-mode caller would hand us undefined */
      var p = origFetch.apply(window, arguments);
      var url = '';
      try {
        var input = arguments[0];
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {}
      if (CART_WRITE.test(url)) {
        try { settle.onCartWrite(url); } catch (e) {}
        try {
          p.then(function () {
            settle.touch();
            try { document.dispatchEvent(new CustomEvent('mg:cart-written')); } catch (e) {}
          }, function () {});
        } catch (e) {}
        if (!busy) {
          try { p.then(function () { queue(200); }, function () {}); } catch (e) {}
        }
      }
      return p;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var u = String(url || '');
    if (CART_WRITE.test(u)) {
      try { settle.onCartWrite(u); } catch (e) {}
      this.addEventListener('load', function () {
        try { settle.touch(); } catch (e) {}
        try { document.dispatchEvent(new CustomEvent('mg:cart-written')); } catch (e) {}
        if (!busy) queue(200);
      });
    }
    return origOpen.apply(this, arguments);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { queue(0); });
  } else {
    queue(0);
  }
})();
